import React from 'react';
import ManagedAccountPageContainer
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageContainer';


const ManagedAccountPageTemplate = () => {
  return <ManagedAccountPageContainer />;
};

export default ManagedAccountPageTemplate;
